<div class="container-fluid full-height pt-5">
  <div class="">
    <div class="col p-0">
      <bd-light-table [gridData]="gridData || []" [pageInfo]="pageInfo" [fields]="fields" [actionsLast]=true
        [actions]="actionItems"></bd-light-table>
      <!-- <lib-ph-bhp-grid [gridData]="gridData" [fields]="fields" [pageInfo]="pageInfo" [actionItems]="actionItems" [horizontalAction]="horizontalAction">
      </lib-ph-bhp-grid> -->
    </div>
  </div>
</div>

<ng-template #delmodal>
  <div class="mb-4 modal-header justify-content-between align-items-center">
    <h5 class="modal-title">{{ translationKeys.InstitutionManagement.Confirmation | translate }}</h5>
    <a class="cursor" data-dismiss="modal" (click)="modalRef.hide();"><img
        src="assets/ph-bhp-layout/svg/remove.svg"></a>
  </div>
  <div class="modal-body">
    <p> {{ 'USER_MANAGEMENT.DELETE_USER' | translate}} </p>
    <br />
    <p> {{ 'USER_MANAGEMENT.DELETE_USER_CONFIRMATION' | translate}} </p>
  </div>
  <div class="modal-footer">
    <div class="align-items-end d-flex">
      <button (click)="modalRef.hide()" class="btn-cancel-bordered-bd separate-buttons">{{ 'BUTTON.CANCEL' | translate }}</button>
      <button (click)="delete();modalRef.hide()" class="btn-bd-empty">{{ 'USER_MANAGEMENT.DELETE' | translate }}</button>
    </div>
  </div>
</ng-template>
